module.exports = false;



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0